import _ from 'lodash';
import React, { Component, Fragment } from 'react';
import { Button, Grid, GridRow, GridColumn } from 'semantic-ui-react';
import ReactTable from 'react-table';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import * as ProductionReportSetupActions from './state/reports/actions';
import * as ProductionReportSetupSelectors from './state/selectors';
import { createToast, toastType } from 'Common/ToastHelper';
import { Modals } from './helpers/Constants';
import { caseInsensitiveFilter } from 'Common/GridHelper';
import { Filter, Main } from 'Containers';
import { errorToast } from 'Common/ToastHelper';
import { CreateProductionReportModal } from './subpages/CreateProductionReportModal';
import { MealTypes, Pages } from './helpers/Constants';

class ProductionReportSetupContainer extends Component {
  state = {
    filtered: [],
  };

  componentDidMount() {
    this.props.getProductionReports();
  }

  componentDidUpdate(prevProps) {
    if (errorToast(this.props, prevProps, 'fetchError')) {
      this.props.clearError();
    }
  }

  onCreateNewReport = () => {
    const { changeModalVisiblity } = this.props;

    changeModalVisiblity(Modals.CreateNewReport, true);
  };

  resetModal = () => {
    const {
      setMealTypes,
      setReportNotes,
      setDetails,
      setOtherDetails,
    } = this.props;

    setMealTypes([]);
    setReportNotes('');
    setDetails('');
    setOtherDetails('');
  }

  onSaveAndCloseCreateNewReport = async () => {
    const {
      mealTypes,
      details,
      otherDetails,
      reportNotes,
      saveReport,
      changeModalVisiblity,
      changePage,
      selectedTemplate,
      history,
    } = this.props;
    let reportName = '';
    const hasOther = _.includes(mealTypes, MealTypes.Other);
    const hasDetails = details !== '';
    const hasOtherDetails = otherDetails !== '';
    let filteredMealTypes = mealTypes.filter((x) => x !== MealTypes.Other);

    reportName = `${filteredMealTypes.join(', ')}${hasDetails ? ': ' : ''}${
      hasDetails ? details : ''
    }`;

    if (hasOther) {
      reportName += `${reportName.length > 0 ? ', ' : ''}${MealTypes.Other}${
        hasOtherDetails ? ': ' : ''
      }${hasOtherDetails ? otherDetails : ''}`;
    }

    const model = {
      reportName,
      reportNotes,
      templateId: selectedTemplate,
    };

    try {
      const data = await saveReport(model);            
      changeModalVisiblity(Modals.CreateNewReport, false);
      changePage(Pages.SelectTemplate);

      if(data.Id === undefined)
      {
        createToast(toastType.error, 'Error', data, true);  
        return;
      }
      else {
        createToast(toastType.success, 'Success', 'New Report Created', true);
      }            

      history.push(`/productionreportsetup/${data.Id}`);

      this.resetModal();
    } catch (ex) {}
  };  

  renderHeader() {
    return (
      <Filter title={'Production Report Setup'}>
        <Grid>
          <GridRow>
            <GridColumn
              width="10"
              floated="left"
              verticalAlign="middle"
            ></GridColumn>
            <GridColumn width="6" floated="right" textAlign="right">
              <Button
                content="Create New Report"
                onClick={this.onCreateNewReport}
              />
            </GridColumn>
          </GridRow>
        </Grid>
      </Filter>
    );
  }

  renderGrid() {
    const data = this.props.data || [];

    return (
      <Main shouldNotUsePageWidth>
        <Button
          className={'clear-filters-button'}
          content="Clear Filters"
          onClick={() => this.setState({ filtered: [] })}
        />
        <ReactTable
          minRows={0}
          loading={this.props.isGridLoading}
          data={data}
          resizable={false}
          className={'-striped -highlight grid--fixed-row-height'}
          defaultFilterMethod={caseInsensitiveFilter}
          filtered={this.state.filtered}
          onFilteredChange={(filtered) => this.setState({ filtered })}
          columns={[
            {
              columns: [
                {
                  Header: 'Report Name',
                  accessor: 'ReportName',
                  filterable: true,
                  resizable: true,
                },
                {
                  Header: 'Report Notes',
                  accessor: 'Description',
                  filterable: true,
                  resizable: true,
                },
                {
                  Header: 'Last Modified Date',
                  accessor: 'LastModifiedDate',
                  filterable: true,
                  resizable: true,
                },
                {
                  Header: 'Report Version',
                  accessor: 'ReportVersion',
                  filterable: true,
                  resizable: true,
                },
              ],
            },
          ]}
        />
      </Main>
    );
  }

  render() {
    const { showCreateNewReportModal, changeModalVisiblity } = this.props;

    return (
      <Fragment>
        {this.renderHeader()}
        {this.renderGrid()}
        {showCreateNewReportModal && (
          <CreateProductionReportModal
            modalProps={{
              onClose: () =>
                changeModalVisiblity(Modals.CreateNewReport, false),
              open: showCreateNewReportModal,
            }}
            onSaveAndClose={this.onSaveAndCloseCreateNewReport}
          />
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    data: ProductionReportSetupSelectors.getData(state),
    fetchError: ProductionReportSetupSelectors.getError(state),
    showCreateNewReportModal: ProductionReportSetupSelectors.getShowCreateNewReportModal(
      state
    ),
    mealTypes: ProductionReportSetupSelectors.getMealTypes(state),
    details: ProductionReportSetupSelectors.getDetails(state),
    otherDetails: ProductionReportSetupSelectors.getOtherDetails(state),
    reportNotes: ProductionReportSetupSelectors.getReportNotes(state),
    selectedTemplate: ProductionReportSetupSelectors.getTemplate(state),
  };
};

const mapDispatchToProps = {
  getProductionReports: ProductionReportSetupActions.getProductionReports,
  clearError: ProductionReportSetupActions.clearError,
  changeModalVisiblity: ProductionReportSetupActions.changeModalVisiblity,
  saveReport: ProductionReportSetupActions.saveReport,
  changePage: ProductionReportSetupActions.changePage,
  setMealTypes: ProductionReportSetupActions.setMealTypes,
  setDetails: ProductionReportSetupActions.setNewReportDetails,
  setOtherDetails: ProductionReportSetupActions.setNewReportOtherDetails,
  setReportNotes: ProductionReportSetupActions.setNewReportNotes,
};

export const ProductionReportSetup = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ProductionReportSetupContainer)
);



// WEBPACK FOOTER //
// ./src/pages/productionreportsetup/ProductionReportSetup.js